// extracted by mini-css-extract-plugin
module.exports = {"container":"Boost_container__2wUYe","Main":"Boost_Main__3-1Mi","ChartSources":"Boost_ChartSources__3P58N","GraphTitle":"Boost_GraphTitle__3Uofe"};